import { Box, Flex } from 'reflexbox';

import { MiniProgressBar } from '@treams/treams-ui/common/MiniProgressBar';
import { Paragraph } from '@treams/treams-ui/common/Text';

import { ratio } from '../CycleAnalytics';

export function ProgressLabel({ value, total }: { value: number; total: number }) {
	return (
		<Flex flexShrink={0} className="grid-progress-label">
			<Paragraph color="antracite" mr={1} flexShrink={0} style={{ whiteSpace: 'nowrap' }}>
				{(ratio(value, total) * 100).toFixed(0)}%
			</Paragraph>
			<Paragraph color="slateBlue" flexShrink={0} style={{ whiteSpace: 'nowrap' }}>
				({value} / {total})
			</Paragraph>
		</Flex>
	);
}

export function GridProgressCell({ value, total }: { value: number; total: number }) {
	const isEmpty = value === 0 && total === 0;

	return (
		<Flex
			flexDirection="column"
			alignItems="flex-start"
			justifyContent="center"
			height="100%"
			flexShrink={0}
		>
			<Box mb={1}>
				{!isEmpty ? (
					<MiniProgressBar value={value} total={total} />
				) : (
					<MiniProgressBar value={0} total={1} />
				)}
			</Box>
			<ProgressLabel value={value} total={total} />
		</Flex>
	);
}
